import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";

import { tap } from "rxjs";

import { PageComponent, CategoryItemComponent, LabeledContainerComponent } from "@shared/components";
import { GlobalService, PilotDataApiService, SettingsApiService } from "@shared/services";
import { CategoryItem } from "@shared/models";

@Component({
  selector: "app-settings",
  standalone: true,
  imports: [PageComponent, CategoryItemComponent, LabeledContainerComponent, CommonModule],
  templateUrl: "./settings.component.html",
  styleUrl: "./settings.component.scss",
})
export class SettingsComponent {
  globalService = inject(GlobalService);
  settingsApiService = inject(SettingsApiService);
  pilotDataApiService = inject(PilotDataApiService);
  router = inject(Router);

  homeSettings: CategoryItem[] = [
    { icon: { icon: "pi pi-calendar", class: "icon red" }, label: "Available PVDs", route: "pvds" },
  ];
  plansSettings: CategoryItem[] = [
    { icon: { icon: "pi pi-clock", class: "icon green" }, label: "VMAX Default", route: "vmax" },
    { icon: { icon: "pi pi-clock", class: "icon blue" }, label: "PROJ Default", route: "proj" },
  ];

  pilotData$ = this.pilotDataApiService.getPilotData(false).pipe(
    tap((response) => {
      this.homeSettings[0].value = response.response?.availablePVDs.toString();
    })
  );
  settings$ = this.settingsApiService.getSettings().pipe(
    tap((response) => {
      this.plansSettings[0].value = response.response?.vMaxDefault;
      this.plansSettings[1].value = response.response?.projDefault;
    })
  );

  getPageHeight(): string {
    return `calc(100vh - ${this.globalService.navbarHeight()}px - 100px)`;
  }

  navigateTo(route: string | undefined): void {
    if (route) {
      this.router.navigate(["settings", route]);
    }
  }
}
